import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: true,
  imports: [CommonModule, PipesModule, DirectivesModule],
})
export class BannerComponent implements OnInit {
  @Input() title: string | null;
  @Input() subtitle: string = '';
  @Input() showBtn: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
